import {
  DateInputRenderer,
  type DateInputRendererProps,
  RadioSelectionRenderer,
  type RadioSelectionRendererProps,
  getRendererProps,
} from '@exam-center/components';
import { Box, Flex, Text } from '@shared/components';

export interface ProctorEndedAtFieldProps {
  fields: {
    isTerminationAssign: RadioSelectionRendererProps;
    endedAt: DateInputRendererProps;
  };
  options?: {
    shouldShowEndedAtDateDisplay?: boolean;
  };
}

export default function ProctorEndedAtField(props: Readonly<ProctorEndedAtFieldProps>) {
  const { fields, options = {} } = props;

  if (fields.endedAt.mode === 'view' && fields.isTerminationAssign.mode === 'view') {
    const shouldDisplayEndedAtDate = options.shouldShowEndedAtDateDisplay;

    if (shouldDisplayEndedAtDate) {
      return (
        <Box sx={{ width: '200px' }}>
          <DateInputRenderer
            {...getRendererProps(fields.endedAt, {
              label: 'วันที่สิ้นสุดปฏิบัติหน้าที่',
            })}
          />
        </Box>
      );
    }

    return (
      <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(2) })}>
        {fields.isTerminationAssign.value}
      </Flex>
    );
  }

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(2) })}>
      <RadioSelectionRenderer
        {...getRendererProps(fields.isTerminationAssign, {
          options: [
            {
              label: (
                <Box>
                  <Text>ไม่มีกำหนด</Text>
                  <Text sx={(theme) => ({ color: theme.palette.text.secondary })} variant='caption'>
                    ยังไม่มีกำหนดวันที่สิ้นสุดปฏิบัติหน้าที่
                  </Text>
                </Box>
              ),
              value: 'false',
            },
            {
              label: (
                <Box>
                  <Text variant='body1'>กำหนดวันที่สิ้นสุดปฏิบัติหน้าที่</Text>
                  <Text sx={(theme) => ({ color: theme.palette.text.secondary })} variant='caption'>
                    ระบุวันที่สิ้นสุดปฏิบัติหน้าที่ด้วยตนเอง
                  </Text>
                </Box>
              ),
              value: 'true',
            },
          ],
          sx: (theme) => ({
            '& .MuiFormControlLabel-root': { alignItems: 'flex-start' },
            '& .MuiRadioGroup-root': { gap: theme.spacing(4) },
            '& .MuiRadio-root': {
              pt: 0,
            },
          }),
          wrapper: { sx: { alignItems: 'flex-start' } },
        })}
      />
      {options?.shouldShowEndedAtDateDisplay ? (
        // REMARK: Add paddings to align with radio button
        <Box sx={{ ml: '30px', width: '200px' }}>
          <DateInputRenderer
            {...getRendererProps(fields.endedAt, {
              label: 'วันที่สิ้นสุดปฏิบัติหน้าที่',
              placeholder: 'DD-MM-YYYY',
              inputFormat: 'DD-MM-YYYY',
              minDate: new Date(),
              required: true,
            })}
          />
        </Box>
      ) : null}
    </Flex>
  );
}
